<template>
    <v-form ref="form">
        <v-row no-gutters align="center" class="pa-2">
            <label class="mr-2 subtitle-1"><b>Title :</b> </label>
            <v-text-field dense outlined hide-details @blur="ctrl.update(ctrl.formData)" v-model="ctrl.formData.title">
            </v-text-field>
        </v-row>

        <v-divider class="my-2"></v-divider>
    </v-form>
</template>

<script>
    export default {
        props: {
            ctrl: Object
        }
    }
</script>